import React from 'react';
import { Row, Col } from 'antd';
import InspectionAppointmentList from '../../inspection-appointments/views/List';
import InspectorWeeklyPlanCard from '../components/InspectorWeeklyPlanCard';

export default function InspectorPlanPage(){
  return (
    <>
      <Row gutter={[16, 16]} className='br-30px mb-16px'>
        <Col xs={24}>
          <InspectorWeeklyPlanCard />
        </Col>
      </Row>
    </>
  );
}
